import { defineComponent, Types } from "bitecs";

export const ModelComponent = defineComponent({
    assetLocation: Types.f32,
    scale: Types.f32,
    rotation: [Types.f32, 3],
});
